// Backend origin the client talks to.
//
// - In development (`npm run dev`) the Vite dev server (:5173) and the game
//   server (:8000) are separate origins, so we hard-code the server's.
// - In a production build the client is served by Caddy on the SAME origin
//   that also reverse-proxies the API + the SocketIO websocket — so the client
//   just uses its own origin and Caddy routes by path. No CORS, no config.
export const SERVER_ORIGIN = import.meta.env.DEV
  ? 'http://localhost:8000'
  : window.location.origin;
